module.exports = [
  {
    "AgeGroup": "75-84 years",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 6208.17
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 6053.07
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 5832.23
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 5394
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 5075.43
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 4757.7
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 4703.8
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 5651.57
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 5420.83
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 5111.67
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 4869.5
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 4691.87
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 4539.4
  },
  {
    "AgeGroup": "75-84 years",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 4429.35
  }
]
